import React from "react";

export default function AddUserSvgIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                d="M9,12A6,6,0,1,0,3,6a6,6,0,0,0,6,6ZM9,2A4,4,0,1,1,5,6,4,4,0,0,1,9,2Z"
                fill="currentColor"
            />
            <path d="M21,10V7H19v3H16v2h3v3h2V12h3V10Z" fill="currentColor" />
            <path
                d="M13.043,14H4.957A4.963,4.963,0,0,0,0,18.957V24H2V18.957A2.96,2.96,0,0,1,4.957,16h8.086A2.96,2.96,0,0,1,16,18.957V24h2V18.957A4.963,4.963,0,0,0,13.043,14Z"
                fill="currentColor"
            />
        </svg>
    );
}
